
import { VirtualRecepcionistTypes } from "./types";
import { VirtualReceptionistDashboard } from "./VirtualReceptionistDashboard";

interface Props {
  type: VirtualRecepcionistTypes;
}


export const VirtualReceptionistWidget = ({ type }: Props) => {
  return <VirtualReceptionistDashboard type={type} />
};